export default function (nga, admin, activities, categories, cfs) {

    var exercise = admin.getEntity('exercises');
    exercise.listView()
        .title('{{ "Exercises" | translate }}')
        .fields([
            nga.field('title')
                .label('Title')
                .isDetailLink(true),
            nga.field('activity_id', 'reference')
                .targetEntity(activities)
                .targetField(nga.field('name'))
                .sortable(false)
                .label('Activity'),
            nga.field('category_id', 'reference')
                .targetEntity(categories)
                .targetField(nga.field('name'))
                .sortable(false)
                .label('Category'),
            nga.field('cognitive_function_id', 'reference')
                .targetEntity(cfs)
                .targetField(nga.field('name'))
                .sortable(false)
                .label('Cognitive Function'),
            nga.field('gds', 'choices')
              .choices([
                  { label: '1', value: 1 },
                  { label: '2', value: 2 },
                  { label: '3', value: 3 },
                  { label: '4', value: 4 },
                  { label: '5', value: 5 },
                  { label: '6', value: 6 },
                  { label: '7', value: 7 }
              ])
              .label('GDS')
              .sortable(false)
        ])
        .filters([
            nga.field('activity_id', 'reference')
                .targetEntity(admin.getEntity('activities'))
                .targetField(nga.field('name'))
                .label('Activity'),
            nga.field('category_id', 'reference')
                .targetEntity(admin.getEntity('categories'))
                .targetField(nga.field('name'))
                .remoteComplete(true)
                .label('Category'),
            nga.field('cognitive_function_id', 'reference')
                .targetEntity(admin.getEntity('cognitive_functions'))
                .targetField(nga.field('name'))
                .label('Cognitive Function'),
            nga.field('q', 'template')
                .label('')
                .pinned(true)
                .template('<div class="input-group"><input type="text" ng-model="value" class="form-control"></input><span class="input-group-addon"><i class="glyphicon glyphicon-search"></i></span></div>')
        ])
        .sortField('title')
        .sortDir('DESC')
        .actions(['create', 'filter'])
        .listActions(['edit']);
    exercise.creationView()
        .fields([
            nga.field('title')
              .attributes({ placeholder: '3 chars min' })
              .validation({ required: true, minlength: 3 }),
            nga.field('objective'),
            nga.field('description', 'text'),
            nga.field('activity_id', 'reference')
                .targetEntity(activities)
                .targetField(nga.field('name'))
                .label('Activity'),
            nga.field('gds', 'choices')
              .choices([
                  { label: '1', value: 1 },
                  { label: '2', value: 2 },
                  { label: '3', value: 3 },
                  { label: '4', value: 4 },
                  { label: '5', value: 5 },
                  { label: '6', value: 6 },
                  { label: '7', value: 7 }
              ])
              .label('GDS'),
            nga.field('cognitive_function_id', 'reference')
                .targetEntity(cfs)
                .targetField(nga.field('name'))
                .label('Cognitive Function'),
            nga.field('category_id', 'reference')
                .targetEntity(categories)
                .targetField(nga.field('name'))
                .label('Category')
        ])
    exercise.editionView()
        .title('{{ "EDIT" | translate }}')
        .fields(exercise.creationView().fields())

    return exercise;
}



// WEBPACK FOOTER //
// ./js/exercises/config.js